import { useEffect, useState } from "react";
import { updateDeliveryBoysForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";

export default function EditDeliveryBoysUi({ deliveryBoysData, deliveryBoyByIdData, search }) {

  const nav = useNavigate();
  const { deliveryBoyId } = useParams();
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const t = i18n.t.bind(i18n);
  const currentLang = i18n.language;

  useEffect(() => {
    // If you need to prefill any helpers via search (like categories example), you can call search here
    const nameText = deliveryBoyByIdData?.name ?? "";
    if (nameText) search && search(nameText);
  }, [deliveryBoyByIdData]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const formData = new FormData(e.target);
    const result = await updateDeliveryBoysForm(deliveryBoyId, formData, navigate);
    setLoading(false);
  };

  const navigate = (route) => {
    nav(route);
  };

  if ((deliveryBoysData || []).length < 1 && Object.entries(deliveryBoyByIdData || {}).length < 1) {
    return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#2F7A74" size="large" text="" textColor="" /></div>
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">

        <div className="mb-4">
          <label className="block text-white mb-2">{currentLang === "en" ? "name" : "الاسم"}</label>
          <input
            type="text"
            defaultValue={deliveryBoyByIdData?.name || ""}
            name="name"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={currentLang === "en" ? "enter name" : "أدخل الاسم"}
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">{currentLang === "en" ? "email" : "البريد الإلكتروني"}</label>
          <input
            type="email"
            defaultValue={deliveryBoyByIdData?.email || ""}
            name="email"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={currentLang === "en" ? "enter email" : "أدخل البريد الإلكتروني"}
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">{currentLang === "en" ? "phone" : "رقم الهاتف"}</label>
          <input
            type="text"
            defaultValue={deliveryBoyByIdData?.phone || ""}
            name="phone"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={currentLang === "en" ? "enter phone" : "أدخل الهاتف"}
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">{currentLang === "en" ? "password" : " كلمة المرور"}</label>
          <input
            type="password"
            name="password"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={currentLang === "en" ? "enter password" : "أدخل كلمة المرور"}
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">{currentLang === "en" ? "confirm password" : "تأكيد كلمة المرور"}</label>
          <input
            type="password"
            name="password_confirmation"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={currentLang === "en" ? "confirm password" : "تأكيد كلمة المرور"}
          />
        </div>

      </div>

      <div className="flex justify-center w-full mt-5">
        <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
          {loading ? (
            <>
              <svg className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            </>
          ) : t("button.save")}
        </button>
      </div>
    </form>
  );
}
